import React, { useCallback, useRef, useState } from 'react';
import { announceMathMenu, MathFormulaMenu } from '../DocEditor/components/MathFormulaMenu';

/**
 * `/math` formula menu for variable value fields.
 * On submit, keeps the formula (live pill) — does not flatten to a number.
 */
export const useFieldMathMenu = ({
  resolveVariable,
  availableVariables = [],
  onCreateVariable = null,
  onInsertExpr,
  onRestoreFocus,
}) => {
  const [menu, setMenu] = useState(null);
  const openRef = useRef(false);

  const closeMenu = useCallback(() => {
    openRef.current = false;
    setMenu(null);
    onRestoreFocus?.();
  }, [onRestoreFocus]);

  const openMathMenu = useCallback((position, initialExpr = '') => {
    announceMathMenu();
    openRef.current = true;
    setMenu({
      position: position || { x: 0, y: 0 },
      initialExpr,
      key: Date.now(),
    });
  }, []);

  const submit = useCallback(
    (expr) => {
      const formula = String(expr ?? '').trim();
      if (!formula) return;
      openRef.current = false;
      setMenu(null);
      onInsertExpr?.(formula);
    },
    [onInsertExpr]
  );

  const mathMenu = menu ? (
    <MathFormulaMenu
      key={menu.key}
      position={menu.position}
      initialExpr={menu.initialExpr}
      resolveVariable={resolveVariable}
      availableVariables={availableVariables}
      onCreateVariable={onCreateVariable}
      onSubmit={submit}
      onClose={closeMenu}
    />
  ) : null;

  return { mathMenu, openMathMenu, mathMenuOpenRef: openRef };
};
